const SELECCIONA_OFERTA = 'selecciona-oferta';
const TIPO_SIM = 'tipo-sim';
const PORTABILIDAD = 'portabilidad';
const DIRECCION_ENVIO = 'direccion-envio'; // INSERTED IN TIPO_SIM
const ACCESO_CUENTA = 'acceso-cuenta';
const METODO_DE_PAGO = 'metodo-de-pago';
const PROCESANDO_COMPRA = 'procesando-compra';
const RESUMEN_COMPRA = 'resumen-compra';
const RESULTADO_COMPRA = 'resultado-compra';

const stepSubtitles = {
    [SELECCIONA_OFERTA]: "Selecciona la oferta que más te guste.", // 1
    [TIPO_SIM]: "Elige el formato y cantidad de entrega de tu(s) SIM(s).", // 2
    [PORTABILIDAD]: "Indica si deseas portar tu número.", // 2
    [DIRECCION_ENVIO]: "Proporciona la dirección de envío.", // 3 INSERTED IN TIPO_SIM
    [ACCESO_CUENTA]: "Inicia sesión o crea una cuenta.", // 4
    [METODO_DE_PAGO]: "Selecciona tu método de pago.",  // 5
    [PROCESANDO_COMPRA]: "Estamos procesando tu compra.", // 6
    [RESUMEN_COMPRA]: "Resumen de compra.", // 8
    [RESULTADO_COMPRA]: "Resultado de tu compra." // 7
};

const stepKeys = [
    SELECCIONA_OFERTA,  // 1
    TIPO_SIM,           // 2
    PORTABILIDAD,       // 3
    ACCESO_CUENTA,      // 4
    METODO_DE_PAGO,     // 5
    RESUMEN_COMPRA,     // 6
    PROCESANDO_COMPRA,  // 7
    RESULTADO_COMPRA,   // 8
    // DIRECCION_ENVIO , // INSERTED IN TIPO_SIM
];

export {  
    SELECCIONA_OFERTA,
    TIPO_SIM,
    PORTABILIDAD,
    DIRECCION_ENVIO,
    ACCESO_CUENTA,
    METODO_DE_PAGO,
    PROCESANDO_COMPRA, 
    RESUMEN_COMPRA,
    RESULTADO_COMPRA,
    stepSubtitles,
    stepKeys
  }